// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mob_NavbarDash{
    position: absolute;
    top: 0;
    /* width: 100vw; */
    color: var(--primary_color);
    z-index: 30;
}


.Mob_Navbar_rightDash{
    position: absolute;
    padding: 4rem 0rem;
    height: auto;
    background-color: white;
    width: 90vw;
  animation: slide_leftDash 0.5s linear;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  
}

@keyframes slide_leftDash {
    0%{
        width: 0%;
    }
    100%{
        width: 90vw;

    }
}
.Mob_Navbar_rightDash >*{
    font-size: 1.2rem;
    color: var(--primary_color);
    padding-bottom:0.4rem ;
    border-bottom: 0.6px solid rgba(0,0,0,0.2) ;
    font-weight: 500;
    letter-spacing: 0.1rem;
    line-height: 0.5;
}
.hideeDash>*{
    display: none;
}
.hidden_animationDash {
    position: absolute;
    background-color: white;
    /* width: 90vw; */
    padding: 4rem 0rem;
    height: auto;
    animation: slide_rightDash 1s linear;
}
.hidden_animationDash> *{
   display: none;
   
}
@keyframes slide_rightDash {
    0%{
        width: 90vw;
    }
    100%{
        width: 0%;

    }
    
}

.burgerDash{
    position: absolute;
    top:1.7rem;
    left: 0rem;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    justify-content: center;
}

.burgerDash>div{

    width: 35px;
    height:6px;
    background-color: white;
    background: var(--bg-dpink)
}

.burgerDash>:nth-child(1){
    animation: burger1Dash 0.5s linear;
    transform: rotate(0deg);
}
@keyframes burger1Dash {
    0%{
        transform: rotate(45deg);
        background: var(--bg-dpink)


    }
    100%{
    transform: rotate(0deg);
    background-color: white;


    }
 }

 .burgerDash>:nth-child(2){
    animation: burger2Dash 0.5s linear;
    transform: rotate(0deg);
}
@keyframes burger2Dash {
    0%{
        transform: rotate(135deg);
        background: var(--bg-dpink)

    }
    100%{
    transform: rotate(0deg);
    background-color: white;



    }
 }

.crossDash>:nth-child(1){
    animation: cross1Dash 0.5s linear;
    transform: rotate(45deg);
    background: var(--bg-dpink)

}
 @keyframes cross1Dash {
    0%{
        transform: rotate(0deg);
    background: var(--bg-dpink)

    }
    100%{
    transform: rotate(45deg);
    background: white



    }
 }
.crossDash>:nth-child(2){
    animation: cross2Dash 0.5s linear;
    transform: rotate(135deg);
    background: var(--bg-dpink)


    
}
@keyframes cross2Dash {
    0%{
    transform: rotate(0deg);
    background: var(--bg-dpink)

    }
    100%{
    transform: rotate(135deg);
    background: white

    }
 }
@media only screen and (min-width: 601px){
    .Mob_NavbarDash{
        display: none;
    }
}
@media screen and (max-width: 380px){
    .burgerDash>div {
        width: 24px;

    }
}


`, "",{"version":3,"sources":["webpack://./src/CmsComponents/MobileNavDash/MobileNavDash.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,WAAW;EACb,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;;AAEX;;AAEA;IACI;QACI,SAAS;IACb;IACA;QACI,WAAW;;IAEf;AACJ;AACA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,sBAAsB;IACtB,2CAA2C;IAC3C,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;AACxC;AACA;GACG,aAAa;;AAEhB;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,SAAS;;IAEb;;AAEJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB;AACJ;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;IACI;QACI,wBAAwB;QACxB;;;IAGJ;IACA;IACA,uBAAuB;IACvB,uBAAuB;;;IAGvB;CACH;;CAEA;IACG,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;IACI;QACI,yBAAyB;QACzB;;IAEJ;IACA;IACA,uBAAuB;IACvB,uBAAuB;;;;IAIvB;CACH;;AAED;IACI,iCAAiC;IACjC,wBAAwB;IACxB;;AAEJ;CACC;IACG;QACI,uBAAuB;IAC3B;;IAEA;IACA;IACA,wBAAwB;IACxB;;;;IAIA;CACH;AACD;IACI,iCAAiC;IACjC,yBAAyB;IACzB;;;;AAIJ;AACA;IACI;IACA,uBAAuB;IACvB;;IAEA;IACA;IACA,yBAAyB;IACzB;;IAEA;CACH;AACD;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,WAAW;;IAEf;AACJ","sourcesContent":[".Mob_NavbarDash{\n    position: absolute;\n    top: 0;\n    /* width: 100vw; */\n    color: var(--primary_color);\n    z-index: 30;\n}\n\n\n.Mob_Navbar_rightDash{\n    position: absolute;\n    padding: 4rem 0rem;\n    height: auto;\n    background-color: white;\n    width: 90vw;\n  animation: slide_leftDash 0.5s linear;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 2rem;\n  \n}\n\n@keyframes slide_leftDash {\n    0%{\n        width: 0%;\n    }\n    100%{\n        width: 90vw;\n\n    }\n}\n.Mob_Navbar_rightDash >*{\n    font-size: 1.2rem;\n    color: var(--primary_color);\n    padding-bottom:0.4rem ;\n    border-bottom: 0.6px solid rgba(0,0,0,0.2) ;\n    font-weight: 500;\n    letter-spacing: 0.1rem;\n    line-height: 0.5;\n}\n.hideeDash>*{\n    display: none;\n}\n.hidden_animationDash {\n    position: absolute;\n    background-color: white;\n    /* width: 90vw; */\n    padding: 4rem 0rem;\n    height: auto;\n    animation: slide_rightDash 1s linear;\n}\n.hidden_animationDash> *{\n   display: none;\n   \n}\n@keyframes slide_rightDash {\n    0%{\n        width: 90vw;\n    }\n    100%{\n        width: 0%;\n\n    }\n    \n}\n\n.burgerDash{\n    position: absolute;\n    top:1.7rem;\n    left: 0rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n    justify-content: center;\n}\n\n.burgerDash>div{\n\n    width: 35px;\n    height:6px;\n    background-color: white;\n    background: var(--bg-dpink)\n}\n\n.burgerDash>:nth-child(1){\n    animation: burger1Dash 0.5s linear;\n    transform: rotate(0deg);\n}\n@keyframes burger1Dash {\n    0%{\n        transform: rotate(45deg);\n        background: var(--bg-dpink)\n\n\n    }\n    100%{\n    transform: rotate(0deg);\n    background-color: white;\n\n\n    }\n }\n\n .burgerDash>:nth-child(2){\n    animation: burger2Dash 0.5s linear;\n    transform: rotate(0deg);\n}\n@keyframes burger2Dash {\n    0%{\n        transform: rotate(135deg);\n        background: var(--bg-dpink)\n\n    }\n    100%{\n    transform: rotate(0deg);\n    background-color: white;\n\n\n\n    }\n }\n\n.crossDash>:nth-child(1){\n    animation: cross1Dash 0.5s linear;\n    transform: rotate(45deg);\n    background: var(--bg-dpink)\n\n}\n @keyframes cross1Dash {\n    0%{\n        transform: rotate(0deg);\n    background: var(--bg-dpink)\n\n    }\n    100%{\n    transform: rotate(45deg);\n    background: white\n\n\n\n    }\n }\n.crossDash>:nth-child(2){\n    animation: cross2Dash 0.5s linear;\n    transform: rotate(135deg);\n    background: var(--bg-dpink)\n\n\n    \n}\n@keyframes cross2Dash {\n    0%{\n    transform: rotate(0deg);\n    background: var(--bg-dpink)\n\n    }\n    100%{\n    transform: rotate(135deg);\n    background: white\n\n    }\n }\n@media only screen and (min-width: 601px){\n    .Mob_NavbarDash{\n        display: none;\n    }\n}\n@media screen and (max-width: 380px){\n    .burgerDash>div {\n        width: 24px;\n\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
